var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EDF9F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16932_411366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0008 8H11.0008C10.6472 8 10.3081 8.14048 10.058 8.39052C9.80798 8.64057 9.66751 8.97971 9.66751 9.33333V22.9333C9.65728 23.1241 9.69978 23.3139 9.79033 23.4821C9.88088 23.6502 10.016 23.7902 10.1808 23.8867C10.3506 23.9715 10.5404 24.0083 10.7296 23.9931C10.9188 23.9778 11.1002 23.911 11.2542 23.8L15.8208 20.8467C15.8739 20.8106 15.9366 20.7912 16.0008 20.7912C16.065 20.7912 16.1278 20.8106 16.1808 20.8467L20.7475 23.8C20.8992 23.9174 21.0819 23.988 21.2731 24.0032C21.4644 24.0184 21.6559 23.9775 21.8243 23.8856C21.9926 23.7936 22.1305 23.6545 22.2211 23.4854C22.3117 23.3163 22.351 23.1244 22.3342 22.9333V9.33333C22.3342 8.97971 22.1937 8.64057 21.9436 8.39052C21.6936 8.14048 21.3545 8 21.0008 8V8ZM14.3942 17.1467L12.5208 15.1067C12.4609 15.0421 12.4144 14.9663 12.3839 14.8836C12.3534 14.8009 12.3397 14.713 12.3434 14.625C12.3471 14.537 12.3682 14.4505 12.4056 14.3707C12.4429 14.2909 12.4957 14.2193 12.5608 14.16C12.6918 14.0418 12.8643 13.9804 13.0405 13.9891C13.2167 13.9979 13.3822 14.0761 13.5008 14.2067L15.2808 16.14L18.8408 11.3333C18.946 11.191 19.1035 11.0963 19.2785 11.07C19.4535 11.0438 19.6318 11.0881 19.7742 11.1933C19.9165 11.2985 20.0112 11.456 20.0375 11.631C20.0637 11.806 20.0194 11.9843 19.9142 12.1267L16.2675 17.0467C16.1636 17.1944 16.0274 17.3166 15.8694 17.4041C15.7114 17.4916 15.5355 17.542 15.3551 17.5517C15.1747 17.5613 14.9945 17.5298 14.8281 17.4597C14.6616 17.3895 14.5133 17.2825 14.3942 17.1467Z",
    fill: "#287D3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16932_411366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessCompleted);
export default __webpack_public_path__ + "static/media/processCompleted.9191d27d2665c6e41b1143829531becd.svg";
export { ForwardRef as ReactComponent };